import { connect } from 'react-redux';
import ZDVLLineIcon from './ZDVLLineIcon';
import { setZDVLLineStatusData } from '../../../store/actions/zdvl';

const mapStateToProps = ({ zdvlReducer }) => ({ zdvlReducer });
const mapDispatchToProps = { setZDVLLineStatusData };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZDVLLineIcon);
